module.exports = __webpack_public_path__ + "img/default-room-image.057fa1d2.png";